<template>
    <b-card no-body>

        <b-modal id="update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <integration-information-update v-model="integrationInformation"></integration-information-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="update"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    name="sintegration-information"
                    :buttons="buttons"
                    pagination="server"
                    search></v-table>
                    
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import CompanyApi from '@/api/company'
import IntegrationInformationUpdate from './components/IntegrationInformationUpdate'

export default {
    components:{
        BCard,
        IntegrationInformationUpdate
    },
    data(){
        return{
            editing:false,
            loading:false,
            integrationInformation:{
                IntegrationServiceId:0,
                IntegrationInformationParams:[]
            },
            fields:[
                { name:"Servis Adı",key:"IntegrationServiceName", thClass:"w-100",sortable:true,sortKey:'IntegrationService.ServiceName'},
                
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit }
            ]
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.integrationInformation.IntegrationServiceId = 0
            this.integrationInformation.IntegrationInformationParams=[]
        },
        createNew(){
            this.clearForm()
            this.$showModal('update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.$refs.table.rowLoading(true)
            this.integrationInformation.IntegrationServiceId = item.IntegrationServiceId
            CompanyApi.IntegrationInformation.GetById(item.IntegrationServiceId)
            .then(res=>{
                this.integrationInformation.IntegrationInformationParams = res.data.Data.map(d=>{
                    return{
                        Key:d.Key,
                        Value:d.Value,
                        ParameterId:d.ParameterId,
                        ParameterName:d.ParameterName,
                        Id:d.Id,
                        VisibleName:d.VisibleName
                    }
                })
                this.$refs.table.rowLoading(false)
            })
            this.$showModal('update')
        },
        update(){
            this.loading = true
            CompanyApi.IntegrationInformation.Update(this.integrationInformation)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('update')
                }
                this.$result(res)
                this.loading = false
            })
        },
        provider(data){
            return CompanyApi.IntegrationInformation.Table(data)
        }
    }
}
</script>

<style>

</style>